export default "__VITE_ASSET__Bir$mO$r__"